// Determines whether a carrier form in the enrollment signing flow was
// successfully prepared. A form that failed AI analysis (or is still
// queued/in-flight) yields zero detected fields — including no signature
// field — so the signing UI would otherwise treat it as "no signature needed"
// and let a member finish enrollment without the carrier's required
// signature. Use isFormNotReady() to surface that case.
// The readiness rule itself is shared with the server's attach-time guard.

export {
  UNPREPARED_FORM_STATUSES,
  isCarrierFormUnprepared,
} from "@shared/utils/formReadiness";
import { isCarrierFormUnprepared } from "@shared/utils/formReadiness";

/**
 * True when a carrier form failed to prepare and can't be safely signed.
 * Broker-generated forms (no `carrierFormId`) are always considered ready —
 * they aren't AI-analyzed.
 *
 * @param assoc      A plan→form association enriched with its `form`.
 * @param fieldCount Number of detected fields on the form.
 */
export function isFormNotReady(assoc: any, fieldCount: number): boolean {
  const isCarrierForm =
    Number(assoc?.form?.carrierFormId ?? assoc?.carrierFormId) > 0;
  if (!isCarrierForm) return false;
  return isCarrierFormUnprepared(assoc?.form?.status, fieldCount);
}
